"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookPipeline = void 0;
const hook_1 = require("./hook");
class HookPipeline {
    constructor(logger) {
        this.logger = logger;
        this.hooks = new Map();
    }
    /**
     * Register the different hooks handlers present on the given object.
     * @param obj - An object with some methods implementing a hook.
     */
    addObjectHandler(obj) {
        var _a;
        if (hook_1.hasHookedMethods(obj)) {
            const hookedMethods = hook_1.getHookedMethods(obj);
            for (const [property, hookClass] of hookedMethods) {
                const hookedMethod = obj[property];
                if (typeof hookedMethod !== "function")
                    continue;
                if (!this.hooks.has(hookClass)) {
                    this.hooks.set(hookClass, []);
                }
                (_a = this.hooks.get(hookClass)) === null || _a === void 0 ? void 0 : _a.push(hookedMethod.bind(obj));
            }
        }
        return this;
    }
    /**
     * Associate a hook definition to a function handler.
     * @param hookClass - The hook class definition
     * @param handler - A function called when the hook is triggered.
     */
    addHandler(hookClass, handler) {
        var _a;
        if (!this.hooks.has(hookClass)) {
            this.hooks.set(hookClass, []);
        }
        (_a = this.hooks.get(hookClass)) === null || _a === void 0 ? void 0 : _a.push(handler);
        return this;
    }
    /**
     * Trigger the given hook, and execute every function implementing it.
     * @param hook
     */
    async execute(hook) {
        var _a;
        this.logger.info("Executing hook", { name: hook.constructor.name });
        const handlers = (_a = this.hooks.get(hook.constructor)) !== null && _a !== void 0 ? _a : [];
        for (const handler of handlers)
            await handler(hook);
    }
}
exports.HookPipeline = HookPipeline;
//# sourceMappingURL=pipeline.js.map